import { render, staticRenderFns } from "./returnToSchool.vue?vue&type=template&id=77c3bb96&scoped=true"
import script from "./returnToSchool.vue?vue&type=script&lang=js"
export * from "./returnToSchool.vue?vue&type=script&lang=js"
import style0 from "./returnToSchool.vue?vue&type=style&index=0&id=77c3bb96&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c3bb96",
  null
  
)

export default component.exports